import { constants } from './constants'

const defaultState = {
  loading: false,
  data: {},
}
export const reducer = (state = defaultState, action) => {
  const { type, payload } = action

  switch (type) {
    case constants.CHECK_CT_CA_ONFLY_INIT: {
      return {
        ...state,
        loading: true,
      }
    }
    case constants.CHECK_CT_CA_ONFLY_SUCCESS: {
      return {
        ...state,
        data: payload.data,
        loading: false,
      }
    }
    case constants.CHECK_CT_CA_ONFLY_FAILED: {
      return {
        error_code: payload.error_code,
        error_message: payload.error_message,
        loading: false,
        data: {},
      }
    }

    default:
      return state
  }
}
